import React from 'react';
import './LanguageSelector.css';
import useTranslation from './hooks/useTranslation';

function LanguageSelector({ className = '' }) {
  const { currentLanguage } = useTranslation();
  const handleLanguageChange = (language) => {
    // Store language preference
    localStorage.setItem('chronolog-language', language);
    
    const currentHash = window.location.hash;
    const url = new URL(window.location);
    
    if (language === 'de') {
      url.searchParams.set('lang', 'de');
    } else {
      url.searchParams.delete('lang');
    }
    
    // Update URL and reload to apply language change
    window.location.href = url.toString() + currentHash;
  };

  return (
    <div className={`language-selector ${className}`}>
      <button 
        className={`language-option ${currentLanguage === 'en' ? 'active' : ''}`}
        onClick={() => handleLanguageChange('en')}
        aria-label="Switch to English"
      >
        🇺🇸 EN
      </button>
      <button 
        className={`language-option ${currentLanguage === 'de' ? 'active' : ''}`}
        onClick={() => handleLanguageChange('de')}
        aria-label="Switch to German"
      >
        🇩🇪 DE
      </button>
    </div>
  );
}

export default LanguageSelector; 